import React from "react"
import PropTypes from "prop-types"

import WidgetStyleWrapper from "QuorumGrassroots/widgets/WidgetStyleWrapper/index"
import { StyledImageWidget } from "QuorumGrassroots/widgets/Image/components/style"

const ImageWidget = (props) => {
    const getAltText = () => {
        if (props.altText) {
            return props.altText
        }
        if (props.title && props.title.trim()) {
            return props.title
        }
        return "Campaign image"
    }

    return (
        <WidgetStyleWrapper
            className="image-widget"
            md={props.colWidth}
            useWidgetStyling={props.useWidgetStyling}
            title={props.title}
        >
            <StyledImageWidget src={props.content} alt={getAltText()} />
        </WidgetStyleWrapper>
    )
}

ImageWidget.propTypes = {
    altText: PropTypes.string,
    colWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    content: PropTypes.string.isRequired,
    title: PropTypes.string,
    useWidgetStyling: PropTypes.bool,
}

ImageWidget.defaultProps = {
    title: "",
    useWidgetStyling: true,
}

export default ImageWidget
